export type OtpPhase = "collect" | "sending" | "code" | "verifying";

export interface OtpState {
  phase: OtpPhase;
  email: string;
  name: string;
  /** i18n key for the current error, or null. */
  errorKey: string | null;
}

export type OtpAction =
  | { type: "SET_EMAIL"; email: string }
  | { type: "SET_NAME"; name: string }
  | { type: "SEND_START" }
  | { type: "SEND_OK" }
  | { type: "SEND_FAIL"; errorKey: string }
  | { type: "VERIFY_START" }
  | { type: "VERIFY_FAIL"; errorKey: string }
  | { type: "EDIT_EMAIL" };

export const initialOtpState: OtpState = {
  phase: "collect",
  email: "",
  name: "",
  errorKey: null,
};

export function otpAuthReducer(state: OtpState, action: OtpAction): OtpState {
  switch (action.type) {
    case "SET_EMAIL":
      return { ...state, email: action.email, errorKey: null };
    case "SET_NAME":
      return { ...state, name: action.name };
    case "SEND_START":
      return { ...state, phase: "sending", errorKey: null };
    case "SEND_OK":
      return { ...state, phase: "code", errorKey: null };
    case "SEND_FAIL":
      return { ...state, phase: "collect", errorKey: action.errorKey };
    case "VERIFY_START":
      return { ...state, phase: "verifying", errorKey: null };
    case "VERIFY_FAIL":
      return { ...state, phase: "code", errorKey: action.errorKey };
    case "EDIT_EMAIL":
      return { ...state, phase: "collect", errorKey: null };
    default:
      return state;
  }
}

/** Maps a thrown error / better-auth error message to a `booking.*` i18n key. */
export function mapOtpError(err: unknown): string {
  const raw =
    typeof err === "object" && err !== null && "message" in err
      ? String((err as { message?: unknown }).message ?? "")
      : String(err ?? "");
  const lower = raw.toLowerCase();
  if (lower.includes("expired")) return "booking.otpErrorExpired";
  if (lower.includes("too many") || lower.includes("attempts")) return "booking.otpErrorAttempts";
  if (lower.includes("invalid") || lower.includes("incorrect")) return "booking.otpErrorWrong";
  return "booking.otpErrorGeneric";
}
